import { LogOut, UserCog } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import type { MenuItem } from '@/types';

import Binoculars from '@/assets/icons/binoculars.svg?react';
import BurgerMenuItem from '@/components/shared/burger-menu-item';
import { SheetClose } from '@/components/ui/sheet';
import useLogout from '@/hooks/get-logout';
import useAuth from '@/hooks/use-auth';

const MenuItems = ({ persistentSearch }: { persistentSearch: string }) => {
  const { t } = useTranslation();
  const { userRoles } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { mutate: logout } = useLogout();

  const onHandleLogout = () => {
    logout();
  };

  const isControlPanel = location.pathname === '/control-panel';

  const burgerMenuItems: MenuItem[] = [];

  const allowedRoles = ['super_admin', 'admin', 'welldev'];

  const hasPermission = userRoles?.some((role) => allowedRoles.includes(role));

  if (hasPermission) {
    burgerMenuItems.push(
      isControlPanel
        ? {
            type: 'action' as const,
            icon: <Binoculars className="size-6" />,
            title: t('menu.survista_live_map'),
            onClick: () => navigate(`/home${persistentSearch}`),
          }
        : {
            type: 'action' as const,
            icon: <UserCog strokeWidth="2.5" />,
            title: t('menu.admin_control_panel'),
            onClick: () => navigate(`/control-panel${persistentSearch}`),
          }
    );
  }

  burgerMenuItems.push({
    type: 'link',
    href: '/home',
    icon: <LogOut strokeWidth="2.5" />,
    title: t('menu.sign_out'),
    onClick: onHandleLogout,
  });

  return (
    <div>
      {burgerMenuItems.map((item) => {
        const { title, icon, onClick } = item;

        return (
          <SheetClose key={title} asChild>
            <BurgerMenuItem onClick={onClick} icon={icon} title={title} asChild />
          </SheetClose>
        );
      })}
    </div>
  );
};
export default MenuItems;
